export default function Contact() {
  return <h1>Contato</h1>;
}
